"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsuranceWellnessHubServiceLibModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const health_controller_1 = require("./health/health.controller");
const health_service_1 = require("./health/health.service");
const acl_service_1 = require("./acl.service");
const acl_guard_1 = require("./acl.guard");
const typeorm_1 = require("@nestjs/typeorm");
const acl_category_action_api_map_entity_1 = require("./entities/acl-category-action-api-map.entity");
const acl_category_action_map_entity_1 = require("./entities/acl-category-action-map.entity");
const role_acl_category_action_map_entity_1 = require("./entities/role-acl-category-action-map.entity");
let InsuranceWellnessHubServiceLibModule = class InsuranceWellnessHubServiceLibModule {
};
exports.InsuranceWellnessHubServiceLibModule = InsuranceWellnessHubServiceLibModule;
exports.InsuranceWellnessHubServiceLibModule = InsuranceWellnessHubServiceLibModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [
            typeorm_1.TypeOrmModule.forFeature([
                acl_category_action_api_map_entity_1.AclCategoryActionApiMap,
                acl_category_action_map_entity_1.AclCategoryActionMap,
                role_acl_category_action_map_entity_1.RoleAclCategoryActionMap,
            ]),
        ],
        controllers: [health_controller_1.HealthController],
        providers: [acl_service_1.AclService, acl_guard_1.AclGuard, health_service_1.HealthService],
        exports: [acl_service_1.AclService, acl_guard_1.AclGuard, typeorm_1.TypeOrmModule],
    })
], InsuranceWellnessHubServiceLibModule);
